import { Component, ViewChild } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { IPayer, PayerODataService, PayerAddressODataService, IAddress } from '@exchange/domain/.'
import { AddressComponent } from '@exchange/ui/shared/controls/address/address.component'
import { forkJoin } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { UtilService } from '@exchange/app/services'

@Component({
  selector: 'app-payers-edit',
  templateUrl: './payers-edit.component.html',
  styleUrls: ['./payers-edit.component.scss'],
  standalone: false
})
export class PayersEditComponent {
  @ViewChild('physicalAddress', { static: true }) physicalAddressComponent: AddressComponent
  @ViewChild('mailingAddress', { static: true }) mailingAddressComponent: AddressComponent

  title = 'Edit Payer'
  model: IPayer = {
    MailingAddress: { CountryId: 0 } as IAddress,
    PhysicalAddress: { CountryId: 0 } as IAddress
  } as IPayer

  busy: any = null

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private odata: PayerODataService,
    private payerAddressService: PayerAddressODataService,
    private toastr: ToastrService,
    private util: UtilService
  ) {
    this.route.params.subscribe(params => {
      const id = +params['id']

      if (id) {
        this.busy = this.odata
          .query()
          .filter(`Id eq ${id}`)
          .exec()
          .subscribe(response => {
            this.busy = null
            if (response.data.length) {
              this.model = response.data[0]

              let filter = ''
              if (this.model) {
                filter = `Id eq ${this.model.MailingAddressId}`
              }
              this.payerAddressService
                .query()
                .filter(filter)
                .exec()
                .subscribe(x => {
                  this.model.MailingAddress = x.data[0]
                })

              if (this.model) {
                filter = `Id eq ${this.model.PhysicalAddressId}`
              }
              this.payerAddressService
                .query()
                .filter(filter)
                .exec()
                .subscribe(x => {
                  this.model.PhysicalAddress = x.data[0]
                })
            } else {
              this.backToList()
            }
          }, this.showError.bind(this))
      } else {
        this.title = 'Add Payer'
        this.model = {
          Id: 0,
          MailingAddressId: null,
          PhysicalAddressId: null,
          PhysicalAddress: { CountryId: 1 },
          MailingAddress: { CountryId: 1 }
        } as IPayer
      }
    })
  }

  onSubmit(): void {
    const errors = [].concat(
      this.mailingAddressComponent.validate(),
      this.physicalAddressComponent.validate()
    )

    if (!this.model.Name) {
      errors.unshift('Name is required.')
    }

    this.toastr.clear()
    if (errors.length > 0) {
      this.toastr.error(errors.join('<br />'))
      return
    }

    const observables = [this.physicalAddressComponent.save(), this.mailingAddressComponent.save()]

    forkJoin(observables).subscribe(([physicalAddress, mailingAddress]) => {
      this.model.PhysicalAddressId = physicalAddress ? +physicalAddress.Id : null
      this.model.MailingAddressId = mailingAddress ? +mailingAddress.Id : null

      const model = {
        Id: +this.model.Id,
        Name: this.model.Name,
        PhysicalAddressId: this.model.PhysicalAddressId || null,
        MailingAddressId: this.model.MailingAddressId || null
      }

      const observable = model.Id
        ? this.odata.put(model as IPayer, model.Id).exec()
        : this.odata.post(model as IPayer).exec()

      this.busy = observable.subscribe(() => {
        if (!this.model.MailingAddressId && this.mailingAddressComponent.model.Id) {
          this.mailingAddressComponent.deleteAddress()
        }

        this.showSuccess('Payer was saved successfully.')
      }, this.showError.bind(this))
    })
  }

  showSuccess(successMessage: string): void {
    this.busy = null
    this.backToList(successMessage)
  }

  showError(response): void {
    this.busy = null

    const msg = this.util.getErrorString(response)

    this.toastr.error(msg)
  }

  backToList(successMessage: string = null): void {
    this.router.navigate(['/system', 'payers'], { queryParams: { successMessage } })
  }
}
